<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',

  data() {
    return {
      loading: true,
    }
  },

  created() {
    this.getSystemBase()
  },

  methods: {
    // 获取 app 配置
    async getSystemBase() {
      this.$toast.loading()
      const res = await this.$http({
        method: 'get',
        url: '/system/base?lang='
      })
      this.loading = false
      this.$toast.clear()
      console.log('获取 app 配置', res);
      const { code, data, msg } = res
      if (code !== 200) return this.$toast.fail(msg)
      if (data.ico) {
        data.ico = data.ico.replace('http://', 'https://')
        document.querySelector('link[rel="icon"]').href = data.ico
      }
      if (data.name) document.title = data.name

      for (let key in data) {
        localStorage.setItem(key, data[key])
      }
    },
  },
}
</script>

<style lang="less"></style>
